module.exports = __webpack_public_path__ + "img/detergent-img.3c1e0552.png";